import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20with%20dramatic%20cinematic%20lighting%2C%20silhouette%20of%20a%20lone%20figure%20standing%20on%20a%20rooftop%20overlooking%20a%20sprawling%20cyberpunk%20cityscape%20at%20sunset%2C%20warm%20golden%20amber%20and%20deep%20crimson%20tones%2C%20atmospheric%20haze%2C%20high%20contrast%2C%20painterly%20style%2C%20emotional%20and%20powerful%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="成人动漫精选推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            {t('hero.title')}
            <span className="block text-accent-400 mt-1">{t('hero.titleHighlight')}</span>
          </h1>
          <p className="text-sm md:text-base text-foreground-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/mystery"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md font-medium text-sm transition-all whitespace-nowrap"
            >
              {t('hero.cta')}
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="#categories"
              className="inline-flex items-center gap-2 border border-background-50/40 hover:border-background-50 text-background-50 px-6 py-3 rounded-md font-medium text-sm transition-all whitespace-nowrap"
            >
              {t('hero.secondary')}
              <i className="ri-arrow-down-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}